import React, {useState} from "react";
import {Spinner} from "react-bootstrap";
import Strings from "../../config/Strings";
import {TigerButton} from "../tiger-button/TigerButton";
import {resendActivationMail} from "../../authentication/Oauth2Service";
import {GetCurrentAccount} from "../../resources/dashboard/DashboardService";
import "./ResendActivationMail.scss";

//Button to send the activation mail again, shown together with EMAIL_CONFIRMATION_REQUIRED.
//The purchase pages do not know the account id, so it is loaded on click if it is not passed.
export function ResendActivationMail({accountId}) {

    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState(null);
    const [sent, setSent] = useState(false);

    const resend = async () => {
        setLoading(true);
        setFeedback(null);

        let id = accountId;
        if (id == null) {
            const accountResponse = await GetCurrentAccount();
            id = accountResponse.error ? null : accountResponse.result?.id;
        }

        const response = id != null ? await resendActivationMail(id) : {error: true};
        if (!response.error) {
            setSent(true);
            setFeedback(Strings.EMAIL_CONFIRMATION_RESEND_SUCCESS);
        } else if (response.status === 409) {
            setSent(true);
            setFeedback(Strings.EMAIL_CONFIRMATION_RESEND_ALREADY_CONFIRMED);
        } else if (response.status === 429) {
            setFeedback(Strings.EMAIL_CONFIRMATION_RESEND_TOO_MANY_REQUESTS);
        } else {
            setFeedback(Strings.EMAIL_CONFIRMATION_RESEND_ERROR);
        }
        setLoading(false);
    }

    return (
        <div className="resend-activation-mail">
            <TigerButton className="resend-activation-mail-button" variant="red" type="button"
                         onClick={() => resend()} disabled={loading || sent}>
                {loading ? <Spinner animation="border" size="sm"/> : Strings.EMAIL_CONFIRMATION_RESEND_BUTTON}
            </TigerButton>
            {feedback && <div role="status" className="resend-activation-mail-feedback">{feedback}</div>}
        </div>
    );
}
